
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FAQKeyword from './FAQKeyword';
import Testimonials from './TestimonialKeyword';

function Punetomahabaleshwerinnovacab() {



    const cardData =
    {
        keyword: 'Pune to Mahabaleshwar Innova Cab Services',
        heading: 'S9 Travels: Pune to Mahabaleshwar Innova Cab Services',
        headingDescription: 'S9 Travels offers comfortable, reliable, and affordable Innova cab services from Pune to Mahabaleshwar. Whether you are planning a family vacation, a romantic getaway, or a nature-filled retreat, our professional drivers and well-maintained fleet ensure a smooth and enjoyable ride. Mahabaleshwar, located around 120 km from Pune, can be reached in approximately 3 to 3.5 hours by road, providing you with a pleasant journey to the scenic hill station.',

        top: 'Top Places to Visit in Mahabaleshwar with S9 Travels',

"topPlaces": [
    {
      "title": "Venna Lake",
      "description": "A serene and popular destination, Venna Lake is perfect for boating and enjoying the picturesque views. It is surrounded by lush greenery, making it an ideal spot for families and couples to relax."
    },
    {
      "title": "Arthur's Seat",
      "description": "One of the most famous viewpoints in Mahabaleshwar, Arthur’s Seat offers panoramic views of the valleys below. It’s named after Arthur Malet and is known for its breathtaking scenery."
    },
    {
      "title": "Pratapgad Fort",
      "description": "This historic fort offers both a challenging trek and stunning views of the surrounding landscape. Pratapgad Fort holds significant historical importance and is a must-visit for history enthusiasts."
    },
    {
      "title": "Mapro Garden",
      "description": "Famous for its delicious strawberry products, Mapro Garden offers a peaceful atmosphere and a chance to taste fresh strawberry-based treats. It is also home to a lovely garden and a cafe for relaxing."
    },
    {
      "title": "Elephant's Head Point",
      "description": "A famous viewpoint in Mahabaleshwar, Elephant’s Head Point is named after a rock formation resembling an elephant's head. It provides breathtaking views of the surrounding hills and valleys."
    },
    {
      "title": "Lingmala Waterfall",
      "description": "A scenic waterfall situated around 6 km from Mahabaleshwar, Lingmala Waterfall is a great place to visit, especially during the monsoon season when the waterfall is at its best."
    },
    {
      "title": "Wilson Point",
      "description": "Wilson Point is the highest point in Mahabaleshwar, offering magnificent sunrise views. The cool breeze and panoramic scenery make it a popular spot among tourists."
    },
    {
      "title": "Chinaman’s Waterfall",
      "description": "A beautiful waterfall located near the main market, Chinaman’s Waterfall is a quiet and scenic spot, perfect for a relaxed day out amidst nature."
    },
    {
      "title": "Babington Point",
      "description": "Another famous viewpoint in Mahabaleshwar, Babington Point offers stunning views of the surrounding valleys, making it a great place for nature lovers and photographers."
    },
    {
      "title": "The Bombay Point (Sunset Point)",
      "description": "A famous destination to watch the sunset, The Bombay Point offers a mesmerizing view of the sun setting over the hills. It is one of the most popular spots for tourists visiting Mahabaleshwar."
    }
],

"services": [
    {
      "name": "Book Pune to Mahabaleshwar Innova Taxi",
      "description": "Looking for a premium and comfortable ride from Pune to Mahabaleshwar? Book an Innova taxi for your journey. Whether it's a family trip, a group outing, or a peaceful getaway, our Innova cabs ensure a smooth and relaxing ride."
    },
    {
      "name": "Pune to Mahabaleshwar Innova Cab Booking",
      "description": "Booking an Innova cab for your Pune to Mahabaleshwar trip is hassle-free! With just a few clicks or a call, you can reserve an Innova for a comfortable, spacious, and luxurious ride to Mahabaleshwar."
    },
    {
      "name": "Pune to Mahabaleshwar Innova Car Rental",
      "description": "Rent an Innova for your Pune to Mahabaleshwar trip and enjoy ample space, premium comfort, and a smooth journey. Ideal for families, friends, or groups, our Innova car rental service is perfect for a relaxed trip to Mahabaleshwar."
    },
    {
      "name": "Pune to Mahabaleshwar One-Way Innova Cab",
      "description": "If you're planning a one-way journey from Pune to Mahabaleshwar, our one-way Innova cabs are an ideal choice. Enjoy a comfortable, door-to-door service without any hassle, whether you’re heading to Mahabaleshwar for a short visit or a weekend getaway."
    },
    {
      "name": "Pune to Mahabaleshwar Round Trip Innova",
      "description": "Looking for a round trip to Mahabaleshwar? Book an Innova taxi for a convenient round-trip service from Pune to Mahabaleshwar. Our experienced drivers will ensure you have a comfortable and safe journey both ways."
    },
    {
      "name": "Pune to Mahabaleshwar Luxury Innova Taxi",
      "description": "Experience luxury and comfort with our luxury Innova taxis for your Pune to Mahabaleshwar trip. Whether it’s for a special occasion or just for a comfortable journey, our luxury vehicles are equipped with the finest amenities to make your ride memorable."
    },
    {
      "name": "Mahabaleshwar Innova Taxi Fare",
      "description": "Looking for the best Innova taxi fares for your trip from Pune to Mahabaleshwar? Our rates are affordable, with transparent pricing that includes fuel, tolls, and driver charges, ensuring there are no hidden costs. You can easily get a quote based on your requirements."
    },
    {
      "name": "Private Innova Taxi for Mahabaleshwar",
      "description": "For a private and personalized travel experience, book an Innova taxi for Pune to Mahabaleshwar. You will have a dedicated driver, ensuring flexibility with stops, comfort, and privacy, whether you're traveling with family, friends, or colleagues."
    },
    {
      "name": "Mahabaleshwar Trip from Pune",
      "description": "Make your Mahabaleshwar trip memorable with a private Innova taxi from Pune. Whether it's a short weekend trip or a multi-day tour, our Innova cabs are ideal for exploring the scenic beauty and tourist attractions in and around Mahabaleshwar."
    },
    {
      "name": "Affordable Innova Cabs for Mahabaleshwar",
      "description": "Travel to Mahabaleshwar without burning a hole in your pocket! Our affordable Innova cabs are perfect for budget-conscious travelers who want comfort and space without the high cost. We offer competitive rates for your Pune to Mahabaleshwar trip."
    },
    {
      "name": "Group Travel to Mahabaleshwar",
      "description": "Going with a large group? Our Innova cabs provide ample space for group travel, making it easier for everyone to travel together in comfort. Whether it’s a family trip or a corporate outing, our Innova cabs are the best choice for group travel to Mahabaleshwar."
    },
    {
      "name": "Mahabaleshwar Tour by Innova from Pune",
      "description": "Experience a relaxing Mahabaleshwar tour by booking an Innova from Pune. Enjoy a comfortable ride while exploring Mahabaleshwar’s scenic viewpoints, temples, and natural beauty, with a driver who knows the best places to visit."
    },
    {
      "name": "Mahabaleshwar Sightseeing Innova",
      "description": "Make your sightseeing experience in Mahabaleshwar even more enjoyable by booking an Innova taxi. Our knowledgeable drivers will take you around the best tourist spots, including Venna Lake, Pratapgad Fort, Wilson Point, and more. The spacious Innova ensures everyone can travel comfortably while sightseeing."
    },
    {
      "name": "Innova for Mahabaleshwar with Driver",
      "description": "If you prefer a relaxed trip, our Innova taxis with driver are the best option. Our drivers are local experts who can guide you around Mahabaleshwar, making sure you don’t miss out on any must-visit locations."
    },
    {
      "name": "Mahabaleshwar Innova Rental",
      "description": "Rent an Innova for your trip to Mahabaleshwar. Enjoy flexibility, comfort, and ample luggage space. Whether you're planning to stay for a few days or just visiting for the day, our Innova rentals provide you with the freedom to travel at your own pace."
    }
  ],

"tableData": [
  ["Book Pune to Mahabaleshwar Innova Taxi", "Pune to Mahabaleshwar Innova Cab Booking"],
  ["Pune to Mahabaleshwar Innova Car Rental", "Pune to Mahabaleshwar One-Way Innova Cab"],
  ["Pune to Mahabaleshwar Round Trip Innova", "Pune to Mahabaleshwar Luxury Innova Taxi"],
  ["Mahabaleshwar Innova Taxi Fare", "Private Innova Taxi for Mahabaleshwar"],
  ["Mahabaleshwar Trip from Pune", "Affordable Innova Cabs for Mahabaleshwar"],
  ["Group Travel to Mahabaleshwar", "Mahabaleshwar Tour by Innova from Pune"],
  ["Mahabaleshwar Sightseeing Innova", "Innova for Mahabaleshwar with Driver"],
  ["Mahabaleshwar Innova Rental", ""]
],
"whychoose": [
  {
    "WhyChooseheading": "Reliable and On-Time Service",
    "WhyChoosedescription": "At S9 Travels, we ensure that your journey from Pune to Mahabaleshwar is punctual and hassle-free. Whether it’s a family vacation, business trip, or a sightseeing tour, we guarantee timely pickups and drop-offs, allowing you to enjoy your time in Mahabaleshwar without worrying about your travel arrangements."
  },
  {
    "WhyChooseheading": "Comfortable and Spacious Vehicles",
    "WhyChoosedescription": "Our Toyota Innova cabs are perfect for long-distance journeys. With ample space, comfortable seating, air conditioning, and well-maintained interiors, your ride from Pune to Mahabaleshwar will be smooth and enjoyable for all passengers."
  },
  {
    "WhyChooseheading": "Experienced and Professional Drivers",
    "WhyChoosedescription": "Our drivers are experienced in handling long-distance trips and are familiar with the best routes from Pune to Mahabaleshwar. They prioritize your comfort and safety, ensuring a smooth, enjoyable, and safe journey throughout your trip."
  },
  {
    "WhyChooseheading": "Affordable and Transparent Pricing",
    "WhyChoosedescription": "S9 Travels offers competitive and transparent pricing for your Pune to Mahabaleshwar trip. We provide a clear breakdown of all costs upfront, with no hidden charges, so you can plan your trip with peace of mind."
  },
  {
    "WhyChooseheading": "Safe and Comfortable Journey",
    "WhyChoosedescription": "Your safety is our priority. All our Innova cabs come equipped with modern safety features such as airbags, seat belts, and GPS tracking. We ensure that your journey to Mahabaleshwar is both comfortable and secure."
  },
  {
    "WhyChooseheading": "24/7 Availability",
    "WhyChoosedescription": "Whether you plan to start your journey early in the morning or return late in the night, S9 Travels is available 24/7 to serve you. Our customer service team is always ready to assist with booking or any other inquiries."
  },
  {
    "WhyChooseheading": "Hassle-Free Booking Process",
    "WhyChoosedescription": "Booking your Pune to Mahabaleshwar Innova cab is easy and convenient with S9 Travels. You can book online via our website or mobile app, or contact our customer service team for assistance with your booking."
  },
  {
    "WhyChooseheading": "Customized Travel Packages",
    "WhyChoosedescription": "We offer customized travel packages for your Pune to Mahabaleshwar trip. Whether you are visiting for sightseeing, a family vacation, or a corporate retreat, we can tailor the trip to suit your specific needs and preferences."
  }
]


























    }



    const faqData = [
        [
          {
            question: 'How can I book a Pune to Mahabaleshwar Innova cab with S9 Travels?',
            answer: 'Booking is simple! You can book your Innova cab online through our website or mobile app, or you can contact our customer service team for personalized assistance.',
          },
          {
            question: 'What is the seating capacity of the Innova cab?',
            answer: 'The Toyota Innova can comfortably accommodate up to 6 passengers, making it perfect for family trips, group outings, or corporate travel.',
          },
          {
            question: 'Are the drivers experienced for long-distance travel to Mahabaleshwar?',
            answer: 'Yes, our drivers are well-versed in long-distance travel and know the best routes to Mahabaleshwar. They ensure a smooth and safe journey, allowing you to relax and enjoy the trip.',
          },
          {
            question: 'What payment options are available for booking an Innova cab from Pune to Mahabaleshwar?',
            answer: 'We offer flexible payment options, including cash, credit/debit cards, and online payments via our app, for your convenience.',
          },
          {
            question: 'Can I book a round-trip from Pune to Mahabaleshwar?',
            answer: 'Yes, we can arrange a round-trip for you. Simply provide us with your return details, and we will ensure a comfortable and timely return journey from Mahabaleshwar.',
          },
          {
            question: 'Are there any extra charges for waiting or detours during the trip?',
            answer: 'Any additional charges for waiting time or detours will be communicated to you upfront. We believe in full transparency, so you know exactly what to expect.',
          },
          {
            question: 'Can I use the Innova cab for sightseeing in Mahabaleshwar?',
            answer: 'Yes, our Innova cabs are available for sightseeing tours in Mahabaleshwar. Visit popular spots like the Mahabaleshwar Temple, Arthur\'s Seat, and other scenic viewpoints with the comfort of a spacious vehicle and a knowledgeable driver.',
          },
          {
            question: 'What is the luggage allowance for an Innova cab?',
            answer: 'The Toyota Innova has ample space for standard luggage. If you have more luggage or specific requirements, please inform us during the booking process, and we will make the necessary arrangements.',
          },
          {
            question: 'Is S9 Travels available for corporate or group travel to Mahabaleshwar?',
            answer: 'Yes, we provide corporate and group travel services to Mahabaleshwar. Whether for business meetings, conferences, or team outings, we ensure that your group has a comfortable and professional experience.',
          },
          {
            question: 'Why should I choose S9 Travels for my Pune to Mahabaleshwar Innova cab booking?',
            answer: 'S9 Travels offers a reliable, comfortable, and affordable journey with professional drivers, well-maintained vehicles, and excellent customer service. We ensure a smooth, safe, and memorable trip to Mahabaleshwar.',
          },
        ]
      ];
      
      const testimonialsData = [
        {
          name: 'Mr. Abhishek Jain',
          designation: 'Customer',
          rating: [1, 1, 1, 1, 1],
          text: '“I booked an Innova cab with S9 Travels for my family trip to Mahabaleshwar, and it was a great experience. The vehicle was clean, comfortable, and spacious. The driver was very professional and knowledgeable about the area. We had a smooth, enjoyable trip!”',
        },
        {
          name: 'Mrs. Meera Shah',
          designation: 'Customer',
          rating: [1, 1, 1, 1, 1],
          text: '“Our visit to Mahabaleshwar was fantastic thanks to S9 Travels. The Innova cab was perfect for our group, and the driver made sure we were comfortable throughout the journey. We had a wonderful time sightseeing and traveling in a spacious vehicle.”',
        },
      ];
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
    
    
    
    
    








    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 8850328441",
            "+91 9552526916",

        ],
        email: "booking@s9travels.com"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "Book Pune To Nashik Cab",
        },
        {
            place: "/images/keyword/2.jpg",
            text: "Book Pune To Ganpatipule Cab",
        },
        {
            place: "/images/keyword/3.jpg",
            text: "Book Pune To Ratnagiri Cab",
        },
        {
            place: "/images/keyword/4.jpg",
            text: "Book Pune To Devkund Cab",
        },
        {
            place: "/images/keyword/5.jpg",
            text: "Book Pune To Goa Cab Taxi",
        },
        {
            place: "/images/keyword/6.jpg",
            text: "Book Pune To Kolhapur Cab",
        },
        {
            place: "/images/keyword/7.jpg",
            text: "Book Pune To Lonavala Cab",
        },

        {
            place: "/images/keyword/8.jpg",
            text: "Book Pune To Alibaug Cab",
        },

        {
            place: "/images/keyword/9.jpg",
            text: "Book Pune To Aurangabad Cab",
        },
        {
            place: "/images/keyword/10.jpg",
            text: "Book Pune To Bhimashankar Cab",
        },

        {
            place: "/images/keyword/11.jpg",
            text: "Book Murud Janjira Cab From Pune",
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Book Pune To Adlabs Imagica Cab",
        },

        {
            place: "/images/keyword/13.jpg",
            text: "Book Pune To Mahabaleshwar Cab",
        },

        {
            place: "/images/keyword/14.jpg",
            text: "Book Pune To Trimbakeshwar Cab",
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Pune Mumbai Pune Round Trip",
        },
        {
            place: "/images/keyword/16.jpg",
            text: " Mumbai Pune Pickup Drop",
        },
        {
            place: "/images/keyword/17.jpg",
            text: "Outstation Cabs From Pune",
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Bus Service In Pune",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "12 Jyotirlinga Yatra From Pune",
        },
        {
            place: "/images/keyword/20.jpg",
            text: " Pune To Grishneshwar Cab Services",
        },
        
        {
            place: "/images/keyword/22.jpg",
            text: "Pune To Malshej Ghat Cab",
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Pune To Pandharpur Cab Service",
        },
        {
            place: "/images/keyword/24.jpg",
            text: "Pune To Panhala Fort Cab Service",
        },
        {
            place: "/images/keyword/25.jpg",
            text: " Pune To Raigad Fort Cab Service",
        },
        {
            place: "/images/keyword/26.jpg",
            text: "Pune To Satara Kas Pathar Cab ",
        },
        {
            place: "/images/keyword/27.jpg",
            text: " Pune To Shirdi Cab Pickup Drop",
        },
    ];


    const images = [
        { src: "/images/ourfleet/1.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/5.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/2.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/3.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/4.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/7.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/8.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/9.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/6.jpg", alt: "Image 1" },

    ];


   
      
    const productSchema = {
        "@context": "https://schema.org",
        "@type": "Product",
        "name": "Pune to Mahabaleshwar Innova Cab",
        "description": "Book an Innova cab for your trip from Pune to Mahabaleshwar with S9 Travels. Offering one-way and round-trip options, affordable Innova car rentals, luxury taxis, and sightseeing tours. Choose a private Innova taxi for a comfortable journey to Mahabaleshwar with driver assistance. Book now for group travel or solo trips!",
        "aggregateRating": {
          "@type": "AggregateRating",
          "bestRating": "5",
          "worstRating": "1",
          "ratingValue": "4.8",
          "ratingCount": "8569"
        }
      };
    
      
      


    return (
        <div>
           
      <Helmet>
        <title>Pune to Mahabaleshwar Innova Cab | Affordable & Luxury Innova Taxi | S9 Travels | Contact: +91 8850328441</title>
        <meta 
          name="description" 
          content="Book Pune to Mahabaleshwar Innova cab with S9 Travels. Get affordable and luxury Innova taxis for one-way and round trips. Private Innova taxi, sightseeing tours, and group travel options available. Reserve your Innova today!" 
        />
        
        {/* Inject JSON-LD Schema */}
        <script type="application/ld+json">
          {JSON.stringify(productSchema)}
        </script>
      </Helmet>
      
<section className="page-title centred">
      <div className="bg-layer" style={{ backgroundImage: 'url(/images/background/page-title.jpg)' }}></div>
      <div className="auto-container">
        <div className="content-box">
        
          <h1>{cardData.keyword}</h1>
        </div>
      </div>
    </section>

      

            <section id="about" className="jarallax text-light">
                <div className="center-y relative text-center">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12 text-center">
                                {/* <h1 className='text-white'>{cardData.keyword}</h1> */}
                            </div>
                            <div className="clearfix"></div>
                        </div>
                    </div>
                </div>
            </section>

            <section>
                <div className="container-fluid" >
                    <div className="row ">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/34.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#322E77', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolorrr'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolorrr">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2'>
                                  <h2 className='whycolor py-3'>Why Choose us for  {cardData.keyword}</h2>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark darkcolor">FAQS {cardData.keyword} For S9 Travels</h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">
                                            <FAQKeyword  faqs={faqData} />

                                                {/* <FAQKeyword faqData={faqData} /> */}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <Testimonials testimonials={testimonialsData} />
                         

                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #252E5B',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#252E5B' }}>
                                            <h4 className=" lead fw-semibold whitt text-darkk">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+918850328441" className="d-block  text-white">+91 8850328441</a>
                                                <a href="tel:+919552526916" className="d-block  text-white">+91 9552526916</a>
                                                


                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#252E5B' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Email</h4>
                                                <a href="mailto:booking@s9travels.com" className=" text-white d-block">
                                                    booking@s9travels.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#252E5B' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> S9 Travels <br/>
                                                    Khandesh Nagar, Ghandharva Nagri, Moshi,Pune, pin-412105
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default Punetomahabaleshwerinnovacab;